import "./Chip.css";

export default function Chip({ label, color, bgColor }) {
	return (
		<div className="chip" style={{ color, backgroundColor: bgColor }}>
			<p>{label}</p>
		</div>
	);
}
